import { ProfilesClient } from '@customink/profiles-sso-spa-client';
import { isBrowser } from '../../constants/constants';

export const profilesClient = isBrowser
  ? new ProfilesClient({
      issuer: process.env.PROFILES_URL,
      clientId: process.env.PROFILES_CLIENT_ID,
      redirectUri: `${window.location.origin}`,
      logoutUri: process.env.PROFILES_LOGOUT_URL,
      redirectToLogoutUriAfterCrossTabLogout: false,
    })
  : (null as any);
